// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: 6rK5Xe1UAz

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSectionModeIcon.module.css"; // plasmic-import: 6rK5Xe1UAz/css

createPlasmicElementProxy;

export type PlasmicSectionModeIcon__VariantMembers = {
  selected: "selected";
  color: "blue" | "red";
};
export type PlasmicSectionModeIcon__VariantsArgs = {
  selected?: SingleBooleanChoiceArg<"selected">;
  color?: MultiChoiceArg<"blue" | "red">;
};
type VariantPropType = keyof PlasmicSectionModeIcon__VariantsArgs;
export const PlasmicSectionModeIcon__VariantProps = new Array<VariantPropType>(
  "selected",
  "color"
);

export type PlasmicSectionModeIcon__ArgsType = {};
type ArgPropType = keyof PlasmicSectionModeIcon__ArgsType;
export const PlasmicSectionModeIcon__ArgProps = new Array<ArgPropType>();

export type PlasmicSectionModeIcon__OverridesType = {
  root?: p.Flex<"button">;
  freeBox?: p.Flex<"div">;
};

export interface DefaultSectionModeIconProps {
  selected?: SingleBooleanChoiceArg<"selected">;
  color?: MultiChoiceArg<"blue" | "red">;
  className?: string;
}

const $$ = {};

function PlasmicSectionModeIcon__RenderFunc(props: {
  variants: PlasmicSectionModeIcon__VariantsArgs;
  args: PlasmicSectionModeIcon__ArgsType;
  overrides: PlasmicSectionModeIcon__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.selected
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <p.Stack
      as={"button"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootcolor_blue]: hasVariant($state, "color", "blue"),
          [sty.rootcolor_red]: hasVariant($state, "color", "red"),
          [sty.rootselected]: hasVariant($state, "selected", "selected")
        }
      )}
    >
      <p.PlasmicImg
        alt={""}
        className={classNames(sty.img___40Pro, {
          [sty.imgcolor_red___40PrOvoG0O]: hasVariant($state, "color", "red"),
          [sty.imgselected___40PrOaaKyR]: hasVariant(
            $state,
            "selected",
            "selected"
          )
        })}
        displayHeight={"40px"}
        displayMaxHeight={"none"}
        displayMaxWidth={"100%"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={"40px"}
        loader={"plasmic"}
        loading={"lazy"}
        src={{
          src: "https://site-assets.plasmic.app/38382dda5935c9c0d7d0cb7901c7b64d.svg",
          fullWidth: 190,
          fullHeight: 150,
          aspectRatio: 1.266667
        }}
      />

      <p.PlasmicImg
        alt={""}
        className={classNames(sty.img__oArLh, {
          [sty.imgcolor_blue__oArLHsHPi]: hasVariant($state, "color", "blue"),
          [sty.imgcolor_red__oArLHvoG0O]: hasVariant($state, "color", "red"),
          [sty.imgselected__oArLHaaKyR]: hasVariant(
            $state,
            "selected",
            "selected"
          )
        })}
        displayHeight={"40px"}
        displayMaxHeight={"none"}
        displayMaxWidth={"none"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={
          hasVariant($state, "selected", "selected") ? "40px" : "40px"
        }
        loader={"plasmic"}
        loading={"lazy"}
        src={{
          src: "https://site-assets.plasmic.app/120d2021b1b844a1d0d748a96b572044.svg",
          fullWidth: 186,
          fullHeight: 150,
          aspectRatio: 1.23913
        }}
      />

      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxselected]: hasVariant($state, "selected", "selected")
        })}
      />
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSectionModeIcon__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSectionModeIcon__VariantsArgs;
    args?: PlasmicSectionModeIcon__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSectionModeIcon__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSectionModeIcon__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionModeIcon__ArgProps,
          internalVariantPropNames: PlasmicSectionModeIcon__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionModeIcon__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSectionModeIcon";
  } else {
    func.displayName = `PlasmicSectionModeIcon.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionModeIcon = Object.assign(
  // Top-level PlasmicSectionModeIcon renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicSectionModeIcon
    internalVariantProps: PlasmicSectionModeIcon__VariantProps,
    internalArgProps: PlasmicSectionModeIcon__ArgProps
  }
);

export default PlasmicSectionModeIcon;
/* prettier-ignore-end */
